export default __webpack_public_path__ + "static/media/nodejs.6f01b9a1.png";